// PathToggle — small pill in the nav that lets visitors flip between the
// "elders" landing and the "kids" landing without losing their place. Sits on
// /adults and /kids only — hidden on /, demo, and authenticated routes.
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ForgetMeNotIcon } from "./ForgetMeNotIcon";
import { TeddyIcon } from "./TeddyIcon";

export function PathToggle() {
    const { t } = useTranslation();
    const location = useLocation();
    const onKids = location.pathname.startsWith("/kids");
    const onAdults = location.pathname === "/adults" || location.pathname.startsWith("/adults/");

    // Only render on the two landing modes.
    if (!onKids && !onAdults) return null;

    function remember(path) {
        try { localStorage.setItem("reminissing.last_path", path); } catch (_) {}
    }

    return (
        <div
            className="hidden lg:inline-flex items-center gap-1 p-1 rounded-full bg-white/70 border border-[#E5E1D8] shadow-rem-soft"
            data-testid="path-toggle"
        >
            <Link
                to="/adults"
                onClick={() => remember("/adults")}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-semibold uppercase tracking-wider transition-all ${onAdults ? "bg-[#4A5A95] text-white shadow-rem-soft" : "text-[#5C5A59] hover:text-[#4A5A95]"}`}
                data-testid="path-toggle-adults"
            >
                <ForgetMeNotIcon size={14} />
                {t("nav_modes.elders")}
            </Link>
            <Link
                to="/kids"
                onClick={() => remember("/kids")}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-semibold uppercase tracking-wider transition-all ${onKids ? "bg-[#A85D62] text-white shadow-rem-soft" : "text-[#5C5A59] hover:text-[#A85D62]"}`}
                data-testid="path-toggle-kids"
            >
                <TeddyIcon size={14} color={onKids ? "#FFFFFF" : "#A85D62"} />
                {t("nav_modes.kids")}
            </Link>
        </div>
    );
}
